var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportedProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projects_Icon",
    "data-name": "Projects Icon",
    transform: "translate(4072 -4498)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(-4072 4530) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "rocket_launch_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M87.334-854.829l5.1-5.1a2.431,2.431,0,0,1,1-.607,2.343,2.343,0,0,1,1.184-.061l1.578.334a27.249,27.249,0,0,0-2.58,3.52,26.16,26.16,0,0,0-1.821,3.824Zm6.221,2.762a18.613,18.613,0,0,1,1.9-4.127,20.011,20.011,0,0,1,2.9-3.642,17.382,17.382,0,0,1,6.1-3.991,11.988,11.988,0,0,1,6.4-.8,12.071,12.071,0,0,1-.789,6.4,17.2,17.2,0,0,1-3.976,6.1,20.375,20.375,0,0,1-3.642,2.9A18.454,18.454,0,0,1,98.29-847.3Zm8.376-3.642a2.331,2.331,0,0,0,1.715.7,2.331,2.331,0,0,0,1.715-.7,2.331,2.331,0,0,0,.7-1.715,2.331,2.331,0,0,0-.7-1.715,2.331,2.331,0,0,0-1.715-.7,2.331,2.331,0,0,0-1.715.7,2.331,2.331,0,0,0-.7,1.715A2.331,2.331,0,0,0,101.931-855.709Zm-.85,14.6-1.942-4.461a26.906,26.906,0,0,0,3.839-1.821,26.617,26.617,0,0,0,3.536-2.58l.3,1.578a2.409,2.409,0,0,1-.061,1.2,2.421,2.421,0,0,1-.607,1.017Zm-11.806-7.071a3.566,3.566,0,0,1,2.58-1.077,3.46,3.46,0,0,1,2.58,1.047,3.512,3.512,0,0,1,1.062,2.58,3.512,3.512,0,0,1-1.062,2.58,6.169,6.169,0,0,1-2.534,1.3,32.209,32.209,0,0,1-4.9.971,31.7,31.7,0,0,1,.971-4.886A6.161,6.161,0,0,1,89.276-848.183Z",
    transform: "translate(-4155 5366.777)",
    fill: "#0469ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportedProjects);
export default __webpack_public_path__ + "static/media/supportedProjects.83c4ab2edc871674503984e44b1f638b.svg";
export { ForwardRef as ReactComponent };